import { Icon } from '@chakra-ui/react';

export default function ForaLogoIcon(props) {
  return (
    <Icon
      width='285'
      height='63'
      viewBox='0 0 285 63'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <path
        d='M0 1.60352H44.6321V12.6473H12.883V24.794H39.9381V35.7447H12.883V61.2371H0V1.60352Z'
        fill='currentColor'
      />
      <path
        d='M63.312 31.4205C63.312 14.3964 76.4715 0.684082 94.8778 0.684082C113.284 0.684082 126.443 14.3964 126.443 31.4205C126.443 48.4445 113.284 62.25 94.8778 62.25C76.4715 62.25 63.312 48.5376 63.312 31.4205ZM113.008 31.4205C113.008 20.8365 105.369 12.371 94.9708 12.371C84.5731 12.371 76.7507 20.8365 76.7507 31.4205C76.7507 42.0045 84.48 50.563 94.9708 50.563C105.462 50.563 113.008 42.0975 113.008 31.4205Z'
        fill='currentColor'
      />
      <path
        d='M149.908 1.60352H175.49C193.067 1.60352 202.269 11.911 202.269 24.701C202.269 32.3399 198.311 39.7024 190.949 43.6573L203.372 61.2343H188.557L179.355 47.2455C177.606 47.5219 176.043 47.7053 174.294 47.7053H162.791V61.2343H149.908V1.60352ZM175.86 36.6643C183.406 36.6643 188.653 31.2341 188.653 24.701C188.653 18.1678 183.409 12.5542 175.953 12.5542H162.793V36.6643H175.86Z'
        fill='currentColor'
      />
      <path
        d='M246.348 1.60352H259.048L285 61.2371H271.934L267.886 51.7589H237.609L233.561 61.2371H220.402L246.354 1.60352H246.348ZM263.832 41.7278L256.929 24.7038C255.09 20.1932 252.788 14.2129 252.695 14.0295C252.602 14.2129 250.303 20.196 248.461 24.7038L241.558 41.7278H263.832Z'
        fill='currentColor'
      />
    </Icon>
  );
}
